module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "erco-tooltip",
    on: {
      "mouseenter": function($event) {
        _vm.handleMouseHover(true)
      },
      "mouseleave": function($event) {
        _vm.handleMouseHover(false)
      }
    }
  }, [_c('div', {
    staticClass: "pictogram_"
  }, [(_vm.invertIcon) ? _c('img', {
    staticClass: "_picto_image",
    attrs: {
      "src": require("@/assets/img/tooltip-info.invers.svg"),
      "alt": "i"
    }
  }) : _c('img', {
    staticClass: "_picto_image",
    attrs: {
      "src": require("@/assets/img/tooltip-info.svg"),
      "alt": "i"
    }
  })]), _vm._v(" "), _c('div', {
    ref: "tooltipBox",
    staticClass: "tooltip-box",
    class: {
      visible: _vm.tooltipVisible
    },
    style: (_vm.tooltipBoxStyle)
  }, [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": _vm.variant
    }
  }, [(_vm.title) ? _c('span', {
    staticClass: "_title"
  }, [_vm._v(_vm._s(_vm.title) + ":")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "_text"
  }, [_vm._v(_vm._s(_vm.text))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18164196"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoTooltip.vue
// module id = 599
// module chunks = 0